<template lang="html">
  <div class="businessUnits">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('clientConfigurationTitle', 'clientConfigurationTitle')}}</h6>
          <div class="element-box">
            <div class="element-info mb-3">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-users text-center">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t('clientConfigurationHeader', 'clientConfigurationHeader')}}</h5>
                      <div class="element-inner-desc">{{ t('clientConfigurationDesc','clientConfigurationDesc') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ResponseInfo  v-if="getResponseInfo.responseName == 'businessUnitList'" class="mb-4"></ResponseInfo>
            <div v-if="!this.mobile" no-body>
                <b-tabs v-model="tabIndex">
                  <b-tab title="Business Units" class="pt-5 pb-5">
                    <BusinessUnitsList/>
                  </b-tab>
                  <b-tab title="Logos / Backgrounds" class="pt-5 pb-5">
                    <BusinessUnitsNavbarImages/>
                  </b-tab>
                </b-tabs>
              </div>
              <div v-else role="tablist">
                <div class="mb-1">
                  <div-header header-tag="header" class="p-1" role="tab">
                    <b-button block href="#" v-b-toggle.accordion-1 variant="primary">{{ t('buUnitsListTab', 'buUnitsListTab') }}</b-button>
                  </div-header>
                  <b-collapse id="accordion-1" accordion="site-setup" role="tabpanel">
                    <div-body class="pt-0" style="padding-top: 0px;">
                      <BusinessUnitsList/>
                    </div-body>
                  </b-collapse>
                </div>
                <div class="mb-1">
                  <div-header header-tag="header" class="p-1" role="tab">
                    <b-button block href="#" v-b-toggle.accordion-2 variant="primary">{{ t('buLogosBackgroundsTab', 'buLogosBackgroundsTab') }}</b-button>
                  </div-header>
                  <b-collapse id="accordion-2" accordion="site-setup" role="tabpanel">
                      <div-body>
                        <BusinessUnitsNavbarImages/>
                      </div-body>
                  </b-collapse>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo'
import BusinessUnitsList from '@/components/Client_Configuration/BusinessUnitsList'
import BusinessUnitsNavbarImages from '@/components/Client_Configuration/BusinessUnitsNavbarImages'
import { mapGetters } from 'vuex'

export default {
  name: 'ClientConfiguration',
  data () {
    return {
      tabIndex: 0,
      mobile: window.innerWidth <= 700
    }
  },
  computed: {
    ...mapGetters(['getResponseInfo'])
  },
  components: {
    ResponseInfo,
    BusinessUnitsList,
    BusinessUnitsNavbarImages
  }
}
</script>

<style lang="css" scoped>
  .tab-pane {
    padding-top: 15px !important;
  }
</style>